import { useState, useEffect } from "react";

// Reads the global NSFW toggle, which gates profile links and photos. Mirrors the
// behaviour the roster tables use: only an explicit "false" opts out, anything else
// (including never having touched the toggle) counts as on.
export function readNsfwMode() {
  return localStorage.getItem("nsfw_mode") !== "false";
}

// Subscribes to the `nsfw-mode-changed` event so components react to the toggle
// without each re-implementing the localStorage plumbing.
export default function useNsfwMode() {
  const [isNsfw, setIsNsfw] = useState(readNsfwMode);

  useEffect(() => {
    const onChanged = (event) => setIsNsfw(Boolean(event.detail));
    setIsNsfw(readNsfwMode());
    window.addEventListener("nsfw-mode-changed", onChanged);
    return () => window.removeEventListener("nsfw-mode-changed", onChanged);
  }, []);

  return isNsfw;
}
